import { isNothing } from 'fun-util';

// Identifies image or text popups that were originally signature fields.
export default popup => !isNothing(popup.eSignSettings);



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/wasRequestSignaturePopup.jsx